import { setSiteThemeColor } from "utils"
import * as types from "../types/systemSettings"
import { getSettings, getSystemLocations } from "services"

export const fetchSystemSettings = () => (
  async (dispatch) => {
    try {
      const response = await getSettings()

      setSiteThemeColor(response.colorPalette)

      delete response.locationOptions

      const {
        lastCall,
        requiredDeliveryTime,
      } = response.instantOrderSettings

      const data = {
        ...response,
        instantOrderSettings: {
          lastCall,
          requiredDeliveryTime,
          lunchWorkingHours: [],
          dinnerWorkingHours: [],
          lunchSchedules: [],
          dinnerSchedules: []
        }
      }

      dispatch({
        type: types.FETCH_SYSTEM_SETTINGS,
        data
      })
    } catch (err) {
      console.log(err)
    }
  }
)

export const fetchSystemLocations = (branchId) => (
  async (dispatch) => {
    try {
      const response = await getSystemLocations({ branchId })

      dispatch({
        type: types.FETCH_SYSTEM_LOCATIONS,
        locationOptions: response
      })
    } catch (err) {
      console.log(err)
    }
  }
)

export const updateSystemSettings = (newSystemSettings) => {
  delete newSystemSettings.locationOptions
  delete newSystemSettings.printSetting

  const {
    lastCall,
    lunchWorkingHours,
    dinnerWorkingHours,
    lunchSchedules,
    dinnerSchedules,
    requiredDeliveryTime,
  } = newSystemSettings.instantOrderSettings

  const data = {
    ...newSystemSettings,
    instantOrderSettings: {
      lastCall,
      requiredDeliveryTime,
      lunchWorkingHours: [lunchWorkingHours.start, lunchWorkingHours.end],
      dinnerWorkingHours: [dinnerWorkingHours.start, dinnerWorkingHours.end],
      lunchSchedules: lunchSchedules.map(lunchSchedule =>
        [lunchSchedule.start, lunchSchedule.end]
      ),
      dinnerSchedules: dinnerSchedules.map(dinnerSchedule =>
        [dinnerSchedule.start, dinnerSchedule.end]
      )
    }
  }

  return {
    type: types.UPDATE_SYSTEM_SETTINGS,
    data
  }
}

export const toggleInstantQrCode = () => ({
  type: types.TOGGLE_INSTANT_QR_CODE
})

export const toggleTemporaryOff = () => ({
  type: types.TOGGLE_TEMPORARY_OFF
})

export const toggleAutoConfirm = () => ({
  type: types.TOGGLE_AUTO_CONFIRM
})

export const toggleAutoCheckout = () => ({
  type: types.TOGGLE_AUTO_CHECKOUT
})

export const toggleKioskMode = () => ({
  type: types.TOGGLE_KIOSK_MODE
})

export const setKioskNumber = (kioskNumber) => ({
  type: types.SET_KIOSK_NUMBER,
  kioskNumber
})

export const setSystemSubdomain = (domain, subdomain) => ({
  type: types.SET_SYSTEM_SUBDOMAIN,
  domain,
  subdomain
})